var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.333008C8.92 0.333008 9.66667 1.07967 9.66667 1.99967C9.66667 2.91967 8.92 3.66634 8 3.66634C7.08 3.66634 6.33333 2.91967 6.33333 1.99967C6.33333 1.07967 7.08 0.333008 8 0.333008ZM2.16667 0.333008C3.08667 0.333008 3.83333 1.07967 3.83333 1.99967C3.83333 2.91967 3.08667 3.66634 2.16667 3.66634C1.24667 3.66634 0.5 2.91967 0.5 1.99967C0.5 1.07967 1.24667 0.333008 2.16667 0.333008ZM13.8333 0.333008C14.7533 0.333008 15.5 1.07967 15.5 1.99967C15.5 2.91967 14.7533 3.66634 13.8333 3.66634C12.9133 3.66634 12.1667 2.91967 12.1667 1.99967C12.1667 1.07967 12.9133 0.333008 13.8333 0.333008Z",
    fill: "#0F111C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreFilled);
export default __webpack_public_path__ + "static/media/more_filled.95226fe5151039151fc924d4125f411a.svg";
export { ForwardRef as ReactComponent };